import React from 'react'

const IntermediateLayouts = () => {
  return (
    <div>
        {/* collapseSixtyThree */}
        <div className="accordion-item mb-2">
            <h2 className="accordion-header" id="headingSixtyThree">
                <button className="accordion-button collapsed d-flex justify-content-between align-items-center border py-2 fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSixtyThree" aria-expanded="false" aria-controls="collapseSixtyThree">
                    Intermediate Layouts <span className="toggle-icon ms-auto"></span>
                </button>
            </h2>
            <div id="collapseSixtyThree" className="accordion-collapse collapse" aria-labelledby="headingSixtyThree" data-bs-parent="#accordionCourses">
                <div className="accordion-body overflow-auto" style={{ maxHeight: '200px' }}>
                    <strong>Layouts & Constraints</strong><br/>
                    <ul>
                        <li>Constraints</li>
                        <li>Guidelines</li>
                    </ul>
                    <strong>Linear Layouts</strong><br/>
                    <ul>
                        <li>Stacking components vertically or horizontally with weights</li>
                    </ul>
                    <strong>Hard Coding</strong><br/>
                    <ul>
                        <li>Developing components in XML</li>
                    </ul>
                    <strong>Radio Buttons</strong><br/>
                    <ul>
                        <li>A group of mutually exclusive selectables</li>
                    </ul>
                    <strong>Activities ,Intent and Data</strong><br/>
                    <ul>
                        <li>Different views of an application</li>
                    </ul>
                    <strong>Calendar View</strong><br/>
                    <ul>
                        <li>Date picker interface</li>
                    </ul>
                    <strong>Number Picker</strong><br/>
                    <ul>
                        <li>To pick a number</li>
                    </ul>
                    <strong>Seek Bars</strong><br/>
                    <ul>
                        <li>A slider bar</li>
                    </ul>
                </div>
            </div>
        </div>

    </div>
  )
}

export default IntermediateLayouts